<div *ngIf="loading" class="overlay">
    <div class="position-absolute top-50 start-50 translate-middle">
        <i class="fas fa-sync-alt fa-5x fa-spin"></i>
    </div>
</div>